<app-header></app-header>
<mat-toolbar class="app-toolbar" color="primary"> </mat-toolbar>

<div class="main-content cf-flex-column cf-justify-content-space-around cf-align-items-center">
  <div class="error-message">
    <div class="mat-headline-6">{{ 'UI.ConnectionError.Title' | translate }}</div>
    <p>{{ 'UI.ConnectionError.Message' | translate }}</p>
  </div>
  <button mat-stroked-button data-test="ReloadButton" color="primary" (click)="reload()">
    {{ 'UI.ConnectionError.Action.Reload' | translate }}
  </button>
</div>
